<template>
  <div class="containerFullHeight">
    <PasswordManagerActivation
      v-if="showActivation"
      data-test-id="PasswordManagerMainPanel_activationPanel"
    />
    <PasswordManagerTabs
      v-if="showTabs"
      :activeTab="activeTab"
      data-test-id="PasswordManagerMainPanel_tabsPanel"
    />
    <PasswordManagerErrorMessage
      v-if="showErrorMessage"
      data-test-id="PasswordManagerMainPanel_errorMessage"
      @retry="retryFetchPasswordManager"
    />
    <LoadingOverlay
      :showLoadingOverlay="showLoadingOverlay"
    />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import LoadingOverlay from 'client/components/LoadingOverlay/LoadingOverlay.vue';
import PasswordManagerActivation from 'client/PasswordManager/components/PasswordManagerActivation.vue';
import PasswordManagerErrorMessage from 'client/PasswordManager/components/PasswordManagerErrorMessage.vue';
import PasswordManagerTabs from 'client/PasswordManager/components/PasswordManagerTabs.vue';

const passwordManagerModule = 'PasswordManagerModule';

export default {
  name: 'PasswordManagerMainPanel',

  components: {
    LoadingOverlay,
    PasswordManagerActivation,
    PasswordManagerErrorMessage,
    PasswordManagerTabs,
  },

  props: {
    activeTab: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isFetching: false,
      hasErrorFetching: false,
    };
  },

  computed: {
    ...mapGetters(passwordManagerModule, {
      isEnabled: 'getPasswordManagerStatus',
    }),

    showActivation() {
      return !this.hasErrorFetching && !this.isFetching && !this.isEnabled;
    },

    showErrorMessage() {
      return this.hasErrorFetching;
    },

    showLoadingOverlay() {
      return this.isFetching;
    },

    showTabs() {
      return !this.hasErrorFetching && !this.isFetching && this.isEnabled;
    },

  },

  created() {
    this.clearPasswordManager();
    this.fetchPasswordManager();
  },

  methods: {
    ...mapActions(passwordManagerModule, [
      'fetchPasswordManagerStatus',
      'clearPasswordManager',
      'removePasswordManager',
    ]),

    async fetchPasswordManager() {
      this.isFetching = true;
      try {
        await this.fetchPasswordManagerStatus();
      } catch (e) {
        this.hasErrorFetching = true;
      } finally {
        this.isFetching = false;
      }
    },

    retryFetchPasswordManager() {
      this.hasErrorFetching = false;
      this.fetchPasswordManager();
    },
  },

};
</script>

<style scoped>
.containerFullHeight {
  height: 100%;
}
</style>
